module.exports = __webpack_public_path__ + "static/apple_mosaic-62b3090eb06b659d0f9bd8fd33edc194.jpg";